<template>
  <div class="availability">
    <!--form-availability 
      :editTMP="editTMP"
    /-->
    <availability
      :data="editTMP"
      :onChange="handleChangeAvailability"
    />
  </div>
</template>
<script>
  //import FormAvailability from './FormAvailability'
  import Availability from '@/components/Availability'
  export default {
    components: {
      //FormAvailability,
      Availability,
    },
    props: {
      editTMP: {
        type: Object,
        require: true
      },
      onCancel: {
        type: Function,
        require: true
      }
    },
    data () {
      return {
        switch1: true,
        switch2: false,
      }
    },
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    methods: {
      handleChangeAvailability (v) {
        console.log('vvvv', v)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .availability {
    padding: 15px;
    // width: calc(100% + 30px);
    background-color: #f3f0f0;
    // margin-left: -15px;
    // margin-right: -15px;
  }
</style>
